import CheckboxDataTable from './CheckboxDataTable';

export default CheckboxDataTable;
